import { makeVar } from "@apollo/client";

export const prescriptionsUrlVar = makeVar("");
export const homedeliveryUrlVar = makeVar("");
